import { useEffect } from "react";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import { stopChimeStreams } from "@core/features/video/utils/stopChimeStreams";

/**
 * Render-null component that stops all Chime-managed media streams
 * when VideoLayout unmounts (e.g., SPA navigation to a non-video page).
 */
export function VideoLayoutCleanup() {
  const meetingManager = useMeetingManager();

  useEffect(() => {
    return () => {
      stopChimeStreams(meetingManager);
    };
  }, [meetingManager]);

  return null;
}
